__turbopack_context__.v({
  "imgWrapper": "LongevityPrograms-module-scss-module__zbW-4W__imgWrapper",
});
